import script from "./RedesignAvailablePlaces.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignAvailablePlaces.vue?vue&type=script&setup=true&lang=js"

import "./RedesignAvailablePlaces.vue?vue&type=style&index=0&id=1cb7651d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb7651d"]])

export default __exports__